/* eslint-disable no-unused-vars */
// import {range} from 'd3-array';
// import {scaleQuantile} from 'd3-scale';
import _ from 'lodash'



export function getLineFeaturesFromSession(session,firebase) {

  var key = session.properties.id;

  var db = firebase.database();
  var ref = db.ref('geoFire/' + key);

  return new Promise(resolve => {

    ref.once("value", (snapshot) => {

      var lineFeatures = []

      const lines = snapshot.val().lines;
      // console.log('lines',lines);

      for(var k in lines) {
        var lineFeature = _getLineFeatureFromRawLine(lines[k],k,session)

        if(lineFeature !== false) {
          // console.log('f',lineFeature);
          lineFeatures.push(lineFeature);
          // firebase.database().ref('geojson/sessions/points/' + key).set(feature);
        }
        else {
          console.log('error creating line feature')
        }
      }

      resolve(lineFeatures);

    }, (errorObject) => {
      console.log("The read failed: " + errorObject.code);
    });
  });





}
function _getLineFeatureFromRawLine(line, lineKey, session) {

  if(!line.size) {
    console.warn('No line size');
    return false;
  }

  if(!line.color) {
    console.warn('No line color');
    return false;
  }


    // get session coord
    var startingCoordinate = session.geometry.coordinates;

    // calculate color
    var r = Math.floor(255*line.color.r)
    var g = Math.floor(255*line.color.g)
    var b = Math.floor(255*line.color.b)

    var color = `rgb(${r}, ${g}, ${b})`;

    // console.log(line.size)

    // console.log('l',line)
    var lineFeature = {
      "type": "Feature",
      "geometry": {
        "type": "LineString",
        "coordinates": _getLineCoordinates(startingCoordinate, line.line)
      },
      "properties" : {
        "id": lineKey,
        "userId": session.userId,
        "size" : line.size,
        "timestamp" : session.timestamp,
        "color": color,
        "linePoints": line.line.length,
      }
    }
    return lineFeature;

}

function _getReducedLineTransform(lineTransform) {
  let arrayReducer = 1

  if      (lineTransform.length > 100) { arrayReducer = 5 }
  else if (lineTransform.length > 50) { arrayReducer = 3 }
  else if (lineTransform.length > 20) { arrayReducer = 2 }

  // forEach

  // dont include all array indexes
  // if(i%arrayReducer !== 0) { return }
}

function _getLineCoordinates(startingCoordinate, lineTransform) {
  // console.log('og size', lineTransform.length)
  //
  // var reducedLineTransform = _getReducedLineTransform(lineTransform);
  //
  // console.log('reduced size:', reducedLineTransform.length)

  let lineCoordinates = []

  _.forEach(lineTransform, (dot, i) => {

    // Get lat
    const xPoint = Math.floor(lineTransform[i].x);
    const yPoint = Math.floor(lineTransform[i].y);
    const zPoint = Math.floor(lineTransform[i].z);

    // new offsets
    const newLatOffset  = 0.00001
    const newLongOffset = 0.00001

    // // old offsets
    // const newLatOffset = 0.000005
    // const newLongOffset = 0.000008

    const gg = -0.007

    let newLat = startingCoordinate[0] + (newLatOffset * xPoint)
    let newLong = startingCoordinate[1] + (newLongOffset * yPoint) + gg


    // add exact lat long to array
    // lineCoordinates.push([newLat,newLong])

    // rounded
    lineCoordinates.push([round(newLat, 10), round(newLong, 10)])


  });

  // const reduced = lineTransform.length - lineCoordinates.length
  // console.log('lineCoordinates.length',lineCoordinates.length)

  return lineCoordinates;

}

function round(x, n) {
  const tenN = Math.pow(10, n);
  return Math.round(x * tenN) / tenN;
}

//
// function _getLineCoordinates_og(startingCoordinate, lineTransform) {
//   console.log('about to create a line of size:', lineTransform.length)
//
//   let lineCoordinates = []
//   let arrayReducer = 1
//
//   if      (lineTransform.length > 100) { arrayReducer = 5 }
//   else if (lineTransform.length > 50) { arrayReducer = 3 }
//   else if (lineTransform.length > 20) { arrayReducer = 2 }
//
//   _.forEach(lineTransform, (dot, i) => {
//
//     // dont include all array indexes
//     if(i%arrayReducer !== 0) { return }
//
//
//     const xPoint = Math.floor(lineTransform[i].x)
//
//     const newLatOffset = 0.000004
//     let newLat = startingCoordinate[0] + (newLatOffset * xPoint)
//
//     const yPoint = Math.floor(lineTransform[i].y)
//
//     const newLongOffset = 0.000008
//     const gg = -0.007
//     let newLong = startingCoordinate[1] + (newLongOffset * yPoint) + gg
//
//
//     // add exact lat long to array
//     // lineCoordinates.push([newLat,newLong])
//
//     // rounded
//     lineCoordinates.push([round(newLat, 4), round(newLong, 4)])
//
//
//   });
//
//   // const reduced = lineTransform.length - lineCoordinates.length
//   // console.log('lineCoordinates.length',lineCoordinates.length)
//
//   return lineCoordinates;
//
// }



// WEBPACK FOOTER //
// ./src/components/pages/Dashboard/v3/firebase.js